/**
 * Canonical vehicle profile URLs: /:username/:public_slug
 * Legacy /v/:username/:slug permanently redirects here.
 */

export function vehicleProfilePath(username: string, slug: string): string {
  const u = username.trim();
  const s = slug.trim();
  if (!u || !s) return '';
  return `/${encodeURIComponent(u)}/${encodeURIComponent(s)}`;
}

export function vehicleProfileUrl(
  username: string,
  slug: string,
  opts?: { origin?: string; ref?: string; search?: string }
): string {
  const origin = (opts?.origin ?? (typeof window !== 'undefined' ? window.location.origin : '')).replace(
    /\/$/,
    ''
  );
  let url = `${origin}${vehicleProfilePath(username, slug)}`;
  const params = new URLSearchParams(opts?.search || '');
  if (opts?.ref) params.set('ref', opts.ref);
  const qs = params.toString();
  if (qs) url += `?${qs}`;
  return url;
}

/** Prefer public_slug; fall back to a display-name slug only when missing. */
export function resolveVehicleNavSlug(vehicle: {
  public_slug?: string | null;
  nickname?: string | null;
  year?: number;
  make?: string;
  model?: string;
  trim?: string;
}): string | null {
  if (vehicle.public_slug) return vehicle.public_slug;
  const display =
    vehicle.nickname ||
    [vehicle.year, vehicle.make, vehicle.model, vehicle.trim].filter(Boolean).join(' ');
  if (!display) return null;
  return display
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}
